var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShUnorderedLine(props) {
  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 14" }, props),
    React.createElement(
      "g",
      { transform: "translate(-356 -116)" },
      React.createElement("rect", { width: 24, height: 2, rx: 1, transform: "translate(356 116)" }),
      React.createElement("rect", { width: 24, height: 2, rx: 1, transform: "translate(356 128)" }),
      React.createElement("rect", { width: 18, height: 2, rx: 1, transform: "translate(356 122)" })
    )
  );
}

export default SvgShUnorderedLine;